module.exports = __webpack_public_path__ + "static/media/about-brand-philosophy.50c6053b.png";